import React from "react";

function TermsOfService() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Terms of Service</h1>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using ServiGo's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use our services.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            ServiGo provides home appliance repair services including but not limited to:
          </p>
          <ul>
            <li>Air Conditioner (AC) repair and maintenance</li>
            <li>Refrigerator/Fridge repair and maintenance</li>
            <li>Geyser repair and installation</li>
            <li>Other household appliance repairs as offered</li>
          </ul>
        </section>

        <section>
          <h2>3. User Accounts and Registration</h2>
          <p>
            To use our services, you must create an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Promptly update any changes to your information</li>
            <li>Accept responsibility for all activities under your account</li>
          </ul>
        </section>

        <section>
          <h2>4. Booking and Service Terms</h2>
          <p>
            <strong>4.1 Booking Process:</strong> All service bookings must be made through our website, mobile app, or customer service hotline. Bookings are subject to availability.
          </p>
          <p>
            <strong>4.2 Appointment Scheduling:</strong> You will receive a confirmed appointment time. Our technician will arrive within the specified time window.
          </p>
          <p>
            <strong>4.3 Service Access:</strong> You agree to provide safe and reasonable access to your premises and the appliance requiring service.
          </p>
          <p>
            <strong>4.4 Cancellations:</strong> Cancellations must be made at least 2 hours before the scheduled appointment. Late cancellations may incur a fee.
          </p>
        </section>

        <section>
          <h2>5. Pricing and Payment</h2>
          <p>
            <strong>5.1 Pricing:</strong> Service prices are as listed on our website at the time of booking. Final pricing may vary based on the actual diagnosis and parts required.
          </p>
          <p>
            <strong>5.2 Payment:</strong> Payment is due upon completion of service. We accept cash, UPI, credit/debit cards, and other payment methods as indicated on our platform.
          </p>
          <p>
            <strong>5.3 Estimates:</strong> We provide cost estimates before beginning work. Additional repairs discovered during service will be communicated for approval before proceeding.
          </p>
        </section>

        <section>
          <h2>6. Service Warranty</h2>
          <p>
            <strong>6.1 Warranty Period:</strong> All repair services come with a 15-day warranty on labor. Parts warranty varies by manufacturer and will be communicated at the time of service.
          </p>
          <p>
            <strong>6.2 Warranty Claims:</strong> To claim warranty service, contact our customer support within the warranty period. Warranty does not cover:
          </p>
          <ul>
            <li>Damage caused by misuse or neglect</li>
            <li>Normal wear and tear</li>
            <li>External damage or accidents</li>
            <li>Repairs performed by unauthorized technicians</li>
          </ul>
        </section>

        <section>
          <h2>7. User Conduct</h2>
          <p>You agree NOT to:</p>
          <ul>
            <li>Use our services for any unlawful purpose</li>
            <li>Attempt to interfere with the proper operation of our website or services</li>
            <li>Provide false or misleading information</li>
            <li>Harass or abuse our technicians or staff</li>
            <li>Resell or attempt to commercialize our services without authorization</li>
          </ul>
        </section>

        <section>
          <h2>8. Intellectual Property</h2>
          <p>
            All content, designs, logos, and materials on ServiGo are the intellectual property of ServiGo. You may not copy, reproduce, distribute, or create derivative works without explicit permission.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            ServiGo shall not be liable for:
          </p>
          <ul>
            <li>Any indirect, incidental, or consequential damages</li>
            <li>Damages to property during service (beyond our control)</li>
            <li>Service delays due to circumstances beyond our reasonable control</li>
            <li>Any loss or damage arising from your failure to follow instructions</li>
          </ul>
          <p>
            Our total liability is limited to the amount paid for the specific service in question.
          </p>
        </section>

        <section>
          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless ServiGo and its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising out of your use of our services or violation of these terms.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users or our business.
          </p>
        </section>

        <section>
          <h2>12. Governing Law</h2>
          <p>
            These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the jurisdiction of courts in Mumbai, Maharashtra.
          </p>
        </section>

        <section>
          <h2>13. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Your continued use of our services after changes are posted constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us:
          </p>
          <ul>
            <li>Email: support@servigo.in</li>
            <li>Phone: 7970503756</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
